export class Menu {
    Id_Plan: number;
    Id_Owner: number;
    UserName: string;
    Id_Profile: number;
    ProfileName: string;
    FullName: string;
    Description: string;
    NWeek: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/menu-model.ts